import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoVentasCompras from "./GraficoVentasCompras";
import GraficoDona from "./GraficoDona";
import ListaInventario from "./ListaInventario";
import { buildDashboardData, formatCurrency, formatNumber } from "./utils";
import "./styles.css";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter,
            dashboard: buildDashboardData(null, filter),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({ loading: true });
        const response = await comprobanteService.dashboardGeneral(filter);

        this.setState({
            dashboard: buildDashboardData(response, filter),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda } = this.state;
        const { kpis, ventasCompras, cuentasCobrar, ordenesCompra, cotizaciones, inventario, esMismoMes } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        // Los textos dependen del periodo ya consultado (no del filtro que
        // se esta editando): un solo mes se compara contra el mes anterior.
        const periodo = esMismoMes ? "Mes" : "Periodo";
        const etiquetaTendencia = `vs ${periodo.toLowerCase()} anterior`;
        const tendencia = (kpi) => `${formatNumber(kpi.tendenciaPct)}%`;
        const formatearMonto = (valor) => formatCurrency(valor, moneda);

        return (
            <div>
                <Header
                    title="Dashboard Resumen General"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="resumen-moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="resumen-kpi-row">
                        <KpiCard
                            icon="shopping-cart"
                            iconColor="#2563eb"
                            iconBackground="#dbeafe"
                            label={`Ventas del ${periodo}`}
                            value={formatearMonto(kpis.ventas[clave].valor)}
                            tendenciaDireccion={kpis.ventas[clave].tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.ventas[clave])}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                        <KpiCard
                            icon="shopping"
                            iconColor="#16a34a"
                            iconBackground="#dcfce7"
                            label={`Compras del ${periodo}`}
                            value={formatearMonto(kpis.compras[clave].valor)}
                            tendenciaDireccion={kpis.compras[clave].tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.compras[clave])}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                        <KpiCard
                            icon="line-chart"
                            iconColor="#7c3aed"
                            iconBackground="#ede9fe"
                            label={`Utilidad del ${periodo}`}
                            value={formatearMonto(kpis.utilidad[clave].valor)}
                            tendenciaDireccion={kpis.utilidad[clave].tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.utilidad[clave])}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                        <KpiCard
                            icon="wallet"
                            iconColor="#ea580c"
                            iconBackground="#ffedd5"
                            label="Flujo de Caja"
                            value={formatearMonto(kpis.flujoCaja[clave].valor)}
                            tendenciaDireccion={kpis.flujoCaja[clave].tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.flujoCaja[clave])}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                    </div>

                    <Row gutter={16} type="flex">
                        <Col className="gutter-row" xs={24} xl={9}>
                            <ChartPanel title="Ventas vs Compras">
                                <GraficoVentasCompras
                                    timeLine={ventasCompras.timeLine}
                                    ventas={ventasCompras[clave].ventas}
                                    compras={ventasCompras[clave].compras}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} md={12} xl={7}>
                            <ChartPanel title="Estado de Cuenta por Cobrar">
                                <GraficoDona
                                    datos={cuentasCobrar[clave]}
                                    formatearValor={formatearMonto}
                                    claveFormato={moneda}
                                    breakpointLeyendaInferior={1600}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} md={12} xl={8}>
                            <ChartPanel title="Inventario">
                                <ListaInventario datos={inventario} moneda={moneda} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16} type="flex">
                        <Col className="gutter-row" xs={24} md={12}>
                            <ChartPanel title="Órdenes de Compra">
                                <GraficoDona datos={ordenesCompra} leyendaEnLinea />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} md={12}>
                            <ChartPanel title="Cotizaciones">
                                <GraficoDona datos={cotizaciones} leyendaEnLinea />
                            </ChartPanel>
                        </Col>

                        {/* Resumen Financiero oculto por ahora: no entra en esta
                            etapa. Para mostrarlo, volver a xl={8} las dos donas y agregar:
                            <Col className="gutter-row" xs={24} xl={8}>
                                <ChartPanel title="Resumen Financiero">
                                    <ResumenFinanciero datos={resumenFinanciero[clave]} moneda={moneda} />
                                </ChartPanel>
                            </Col> */}
                    </Row>
                </Spin>
            </div>
        );
    }
}
